(function () {
  'use strict';

  if (window.FellinoraCommunityHeroLoaded) {
    return;
  }

  window.FellinoraCommunityHeroLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function getDistribution(count) {
    return count > 0 ? [4, 4, 4] : [];
  }

  function getLatitudes(length, compactMode) {
    if (length === 1) {
      return [0];
    }

    if (length === 2) {
      return compactMode ? [34, -34] : [36, -36];
    }

    return compactMode ? [48, 0, -48] : [54, 0, -54];
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function syncCards(sphere) {
    var staleClones = Array.prototype.slice.call(sphere.querySelectorAll('[data-fch-clone]'));

    staleClones.forEach(function (clone) {
      clone.remove();
    });

    var originals = Array.prototype.slice.call(sphere.querySelectorAll('[data-fch-card]'));

    if (!originals.length) {
      return [];
    }

    var cards = originals.slice(0, 12);

    while (cards.length < 12) {
      var source = originals[cards.length % originals.length];
      var clone = source.cloneNode(true);

      clone.removeAttribute('data-fch-card');
      clone.setAttribute('data-fch-clone', 'true');
      clone.setAttribute('aria-hidden', 'true');
      sphere.appendChild(clone);
      cards.push(clone);
    }

    return cards;
  }

  function positionCards(stage, cards) {
    var baseRadius = Number(stage.getAttribute('data-radius')) || 190;
    var available = Math.min(stage.clientWidth, stage.clientHeight);
    var compactMode = window.innerWidth <= 749;
    var responsiveRadius = compactMode
      ? Math.min(baseRadius, Math.max(92, available * 0.285))
      : Math.min(baseRadius, Math.max(110, available * 0.34));
    var distribution = getDistribution(cards.length);
    var latitudes = getLatitudes(distribution.length, compactMode);
    var cardIndex = 0;

    distribution.forEach(function (ringCount, ringIndex) {
      var lat = latitudes[ringIndex] || 0;
      var offset = 0;

      for (var slot = 0; slot < ringCount; slot += 1) {
        var card = cards[cardIndex];

        if (!card) {
          return;
        }

        var lng = offset + slot * (360 / ringCount);

        card.style.transform =
          'rotateY(' + lng.toFixed(2) + 'deg) rotateX(' + (-lat).toFixed(2) + 'deg) translateZ(' + responsiveRadius.toFixed(2) + 'px)';

        cardIndex += 1;
      }
    });
  }

  function initStage(section) {
    if (!section || section.dataset.fchInitialized === 'true') {
      return;
    }

    var stage = section.querySelector('[data-fch-stage]');
    var sphere = section.querySelector('[data-fch-sphere]');
    var cards = sphere ? syncCards(sphere) : [];

    if (!stage || !sphere || !cards.length) {
      section.dataset.fchInitialized = 'true';
      return;
    }

    var state = {
      rotX: Number(stage.getAttribute('data-start-tilt')) || 12,
      rotY: 18,
      autoVelocity: 0,
      velocityX: 0,
      velocityY: 0,
      lastX: 0,
      lastY: 0,
      dragging: false,
      paused: false,
      rafId: 0,
      lastFrame: 0
    };

    function render() {
      sphere.style.transform = 'rotateX(' + state.rotX.toFixed(2) + 'deg) rotateY(' + state.rotY.toFixed(2) + 'deg)';
    }

    function updatePointer(clientX, clientY) {
      var dx = clientX - state.lastX;
      var dy = clientY - state.lastY;

      state.rotY += dx * 0.42;
      state.rotX -= dy * 0.3;
      state.rotX = clamp(state.rotX, -72, 72);
      state.velocityY = dx * 0.32;
      state.velocityX = -dy * 0.26;
      state.lastX = clientX;
      state.lastY = clientY;
      render();
    }

    function onPointerDown(event) {
      state.dragging = true;
      state.lastX = event.clientX;
      state.lastY = event.clientY;
      stage.classList.add('is-dragging');

      if (typeof stage.setPointerCapture === 'function') {
        stage.setPointerCapture(event.pointerId);
      }
    }

    function onPointerMove(event) {
      if (!state.dragging) {
        return;
      }

      updatePointer(event.clientX, event.clientY);
    }

    function onPointerUp(event) {
      if (!state.dragging) {
        return;
      }

      state.dragging = false;
      stage.classList.remove('is-dragging');

      if (typeof stage.releasePointerCapture === 'function') {
        try {
          stage.releasePointerCapture(event.pointerId);
        } catch (error) {
        }
      }
    }

    function loop(timestamp) {
      if (!state.lastFrame) {
        state.lastFrame = timestamp;
      }

      var dt = timestamp - state.lastFrame;
      var autoSpeed = Number(stage.getAttribute('data-auto-speed')) || 0;
      var autoTarget = !state.dragging && !state.paused && !reduceMotion.matches ? autoSpeed : 0;
      var autoEase = 1 - Math.exp(-dt * 0.0022);

      state.lastFrame = timestamp;
      state.autoVelocity += (autoTarget - state.autoVelocity) * autoEase;

      if (!state.dragging) {
        state.rotY += dt * 0.0036 * state.autoVelocity;

        state.rotX += state.velocityX * 0.03;
        state.rotY += state.velocityY * 0.03;
        state.rotX = clamp(state.rotX, -72, 72);
        state.velocityX *= 0.92;
        state.velocityY *= 0.92;
        render();
      }

      state.rafId = window.requestAnimationFrame(loop);
    }

    function onResize() {
      positionCards(stage, cards);
      render();
    }

    positionCards(stage, cards);
    render();

    stage.addEventListener('pointerdown', onPointerDown);
    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerup', onPointerUp);
    window.addEventListener('pointercancel', onPointerUp);
    stage.addEventListener('mouseenter', function () {
      state.paused = true;
    });
    stage.addEventListener('mouseleave', function () {
      state.paused = false;
    });
    window.addEventListener('resize', onResize);

    state.rafId = window.requestAnimationFrame(loop);
    section.dataset.fchInitialized = 'true';
  }

  function init(root) {
    (root || document).querySelectorAll('[data-fch-section]').forEach(initStage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
